import React, { useEffect, useState } from 'react'
import { Popover, Button, Modal, Row, Col, Card, Calendar, theme, message } from 'antd';
import dayjs from 'dayjs'
import axios from "axios";
import 'react-calendar/dist/Calendar.css';


const SmallCalendar = ({
    default_date_range_values = [dayjs(), dayjs()],
    date_range_values,
    default_weekday_value = [],
    weekday_value,
    default_class_name_value = "",
    class_name_value,
    default_make_up_date_value = [],
    make_up_date_value,
    circle_item,
    default_circle_item = [],
    isPropsGetHoliday = false,
    propsHolidays = [],
    onDateRangeChange = () => { },
    onWeekdayChange = () => { },
    onHolidayChange = () => { },
    onMakeUpChange = () => { },
    onDateSelect = () => { },
    getSelectedDate = () => { },
    getSelectedTotal = () => { },
}) => {

    dayjs.locale('zh-tw');


    const { token } = theme.useToken();
    const wrapperStyle = {
        width: 300,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
    };
    const onPanelChange = (value, mode) => {
        // console.log(value.format('YYYY-MM-DD'), mode);
    };
    const onSelect = (date) => {
        // console.log(dayjs(date).format('YYYY-MM-DD'))
    }
    const [date_range, setDateRange] = useState(date_range_values ? date_range_values : default_date_range_values);
    // const [date_range, setDateRange] = useState(["2023-05-01", "2023-06-31"]);
    const [weekday, setWeekday] = useState(weekday_value ? weekday_value : default_weekday_value);
    const [class_name, setClassName] = useState(class_name_value ? class_name_value : default_class_name_value);
    const [holiday_temp, setHolidayTemp] = useState([]);
    const [holiday, setHoliday] = useState([]);
    const [make_up_date, setMakeUpDate] = useState(make_up_date_value ? make_up_date_value : default_make_up_date_value);
    const [circle_items, set_circle_items] = useState(circle_item ? circle_item : default_circle_item);
    const zhtw_week = ["天", "一", "二", "三", "四", "五", "六"];


    useEffect(() => {
        setDateRange(date_range_values)
    }, [date_range_values])
    useEffect(() => {
        onDateRangeChange(date_range)
        get_holiday()

        let selected_date_array = []
        let start_date = dayjs(date_range[0])
        let end_date = dayjs(date_range[1]).add(1, 'day')
        while (start_date.isBefore(end_date.format("YYYY-MM-DD"))) {
            if (weekday.includes(start_date.day())) {
                let duplicates_day_for_multiple_class = 0;
                weekday.forEach(element => {
                    if (element == start_date.day()) {
                        duplicates_day_for_multiple_class++
                    }
                })
                for (let i = 0; i < duplicates_day_for_multiple_class; i++) {
                    selected_date_array.push(start_date.format("YYYY-MM-DD"))
                }
            }
            start_date = start_date.add(1, 'day')
        }
        getSelectedDate(selected_date_array)
        getSelectedTotal(selected_date_array.length)

    }, [date_range])
    useEffect(() => {
        if (weekday_value) {
            setWeekday(weekday_value)
            let selected_week = []
            for (let i = 0; i < holiday_temp.length; i++) {
                for (let j = 0; j < weekday_value.length; j++) {
                    if (holiday_temp[i]["week"] === zhtw_week[weekday_value[j]]) {
                        selected_week.push(holiday_temp[i])
                    }
                }
            }

            setHoliday(selected_week);
        }
    }, [weekday_value])
    useEffect(() => {
        onWeekdayChange(weekday)

        let selected_date_array = []
        let start_date = dayjs(date_range[0])
        let end_date = dayjs(date_range[1]).add(1, 'day')
        console.log({
            date_range: date_range,
            start_date: dayjs(start_date).format("YYYY-MM-DD"),
            end_date: dayjs(end_date).format("YYYY-MM-DD"),
        })
        while (start_date.isBefore(end_date.format("YYYY-MM-DD"))) {
            if (weekday.includes(start_date.day())) {
                let duplicates_day_for_multiple_class = 0;
                weekday.forEach(element => {
                    if (element == start_date.day()) {
                        duplicates_day_for_multiple_class++
                    }
                })
                for (let i = 0; i < duplicates_day_for_multiple_class; i++) {
                    selected_date_array.push(start_date.format("YYYY-MM-DD"))
                }
            }
            start_date = start_date.add(1, 'day')
        }
        getSelectedDate(selected_date_array)
        getSelectedTotal(selected_date_array.length)

    }, [weekday])
    useEffect(() => {
        // console.log(holiday)
        // setHoliday_tmp(holiday)
        // if (holiday.length != 0) {
        onHolidayChange(holiday)
        // }
    }, [holiday])
    useEffect(() => {
        setMakeUpDate(make_up_date_value)
    }, [make_up_date_value])
    useEffect(() => {
        onMakeUpChange(make_up_date)
    }, [make_up_date])
    useEffect(() => {
        if (!(weekday_value) && default_weekday_value && holiday_temp.length != 0) {
            let selected_week = []
            for (let i = 0; i < holiday_temp.length; i++) {
                for (let j = 0; j < default_weekday_value.length; j++) {
                    if (holiday_temp[i]['week'] === zhtw_week[default_weekday_value[j]]) {
                        selected_week.push(holiday_temp[i])
                    }
                }
            }
            setHoliday(selected_week);
        }
    }, [holiday_temp])
    useEffect(() => {
        if (!!isPropsGetHoliday) {
            get_holiday()
        }
    }, [propsHolidays])

    const get_holiday = () => {
        if (date_range.length !== 0) {
            if (date_range[0] !== '' && date_range[1] !== '') {
                if (isPropsGetHoliday) {
                    console.log({
                        propsHolidays
                    })
                    setHolidayTemp((pre) => {
                       let temppropsHolidays = propsHolidays.map((date) => {
                            if (date?.isholiday === "1" && date?.description !== "" && date?.description !== "調整放假") {
                                return date
                            }
                        }).filter(dates => dates !== undefined)
                        console.log({temppropsHolidays})
                        return temppropsHolidays
                    })

                }
                else {
                    axios
                        .get(`/holidays`, { params: date_range })
                        .then((response) => {
                            let res_data = response.data
                            if (Array.isArray(res_data)) {
                                setHolidayTemp((pre) => {
                                    return res_data.map((date) => {
                                        if (date?.isholiday === "1" && date?.description !== "" && date?.description !== "調整放假") {
                                            return date
                                        }
                                    }).filter(dates => dates !== undefined)
                                })
                            }
                            else {
                                message.error("日期超出國定假日判斷範圍 無法計算")
                                setHolidayTemp([])
                            }

                        })
                }

            }
        }
    }




    return (<>
        {/* <Card>
            <Row>
                <Col span={24}>
                    <div style={wrapperStyle}> */}
        <Calendar
            fullscreen={false}
            onPanelChange={onPanelChange}
            onSelect={onDateSelect}
            dateFullCellRender={(every_date) => {
                let holiday_description = <></>
                let style = <div style={{ backgroundColor: "#FFFFFF" }}>{every_date.format("DD")}</div>
                // if(holiday.length !== 0) {
                //     style = holiday.map((item) => {
                //         if(item.date === every_date.format("YYYY/MM/DD")) {
                //             return (<Popover content={<div><p>{item.description}</p></div>} title="節日">
                //                         <div style={{ backgroundColor: "#ADD8E6"}}>
                //                             {every_date.format("DD")}
                //                         </div>
                //                     </Popover>)
                //         }
                //         else {
                //             return (<div style={{ backgroundColor: "#FFFFFF"}}>{every_date.format("DD")}</div>)
                //         }
                //     })
                // }
                if (dayjs(date_range[0]).add(-1, 'day').isBefore(every_date.format("YYYY-MM-DD")) && dayjs(date_range[1]).add(1, 'day').isAfter(every_date.format("YYYY-MM-DD")) && weekday.includes(every_date.day())) {
                    style = <Popover content={<div><p>{class_name}</p>{holiday_description}</div>} title="課程">
                        <div style={{ backgroundColor: "#FFFFE0", border: "2px solid red", borderRadius: "20%" }}>{every_date.format("DD")}</div>
                    </Popover>
                    if (holiday.length !== 0) {
                        for (let i = 0; i < holiday.length; i++) {
                            if (holiday[i]["date"] === every_date.format("YYYY/MM/DD")) {
                                holiday_description = <><br /><p>節日：{holiday[i]["description"]}</p></>
                                style = <Popover content={<div><p>{class_name}</p>{holiday_description}</div>} title="課程">
                                    <div style={{ backgroundColor: "#ADD8E6", border: "2px solid red", borderRadius: "20%" }}>
                                        {every_date.format("DD")}
                                    </div>
                                </Popover>
                                break
                            }
                        }
                    }
                    if (make_up_date.length !== 0) {
                        for (let i = 0; i < make_up_date.length; i++) {
                            if (make_up_date[i]["original_date"] === every_date.format("YYYY-MM-DD")) {
                                style = <Popover content={<div><p>{class_name}</p>{holiday_description}</div>} title="課程">
                                    <div style={{ backgroundColor: "#ADD8E6" }}>
                                        {every_date.format("DD")}
                                    </div>
                                </Popover>
                                break
                            }
                            if (make_up_date[i]["is_make_up"] === "1") {
                                if (make_up_date[i]["make_up_date"] === every_date.format("YYYY-MM-DD")) {
                                    style = <Popover content={<div><p>{class_name}(補課)</p></div>} title="課程">
                                        <div style={{ backgroundColor: "#FFFFE0", border: "2px solid red", borderRadius: "20%" }}>
                                            {every_date.format("DD")}
                                        </div>
                                    </Popover>
                                    break
                                }
                            }
                        }
                    }
                }
                if (circle_items.length !== 0) {
                    for (let i = 0; i < circle_items.length; i++) {
                        if (circle_items[i]["date"] === every_date.format("YYYY-MM-DD")) {
                            style = <div style={{ backgroundColor: "#FFFFE0", border: "2px solid red", borderRadius: "20%" }}>
                                {every_date.format("DD")}
                            </div>
                            break
                        }
                    }
                }
                return (<>{style}</>)
            }
            }
        />
        {/* </div>
                </Col>
            </Row>
        </Card>
        <br /> */}
    </>)
}


const Demo = () => {
    return (<>
        <SmallCalendar
            date_range_values={["2023-05-20", "2023-06-30"]}  // RangePicker 的 dateString value
            weekday_value={['1', '2']}  // 星期幾：0是星期天，1是星期一，以此類推... 6是星期六
            class_name_value={"網路程式設計"}  // 課程名稱
        />
    </>)
}


export default SmallCalendar
